// extracted by mini-css-extract-plugin
export default {"container":"GarudaIntroductionText_container__7phZH","card":"GarudaIntroductionText_card__M1bNz","garudaCard":"GarudaIntroductionText_garudaCard__iunUC"};